export class PhoneTypeModel {
  public pht_key: string = undefined;
  public pht_code: string = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }}
